import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { BreachPathAppDataProviderFactory } from '../factory/BreachPathAppDataProviderFactory';
import { BreachPathAppBaseDataProvider } from '../dataProvider/BreachPathAppBaseDataProvider';
import { BreachPathAppWebComponentSchema } from '../types';

export class BreachPathAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: BreachPathAppDataProviderFactory;
  public dataProvider: BreachPathAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new BreachPathAppDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<BreachPathAppWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }

  async getBreachPathIssueDataById(issueId: string): Promise<BreachPathAppWebComponentSchema> {
    return this.dataProvider.getBreachPathIssueDataById(issueId);
  }
}
